import { createElement, Component } from 'rlink-react';
import { TimelineMax } from 'gsap';

import IconPopulation from 'components/svg/iconPopulation';
import IconLocation from 'components/svg/iconLocation';
import IconNationalPark from 'components/svg/iconNationalPark';
import contentLoader from 'helpers/contentLoader';
import cityScene from 'helpers/scenes/cityScene';
import statsScene from 'helpers/scenes/statsScene';
import legacyIsDesktop from 'helpers/legacyIsDesktop';
import Picture from 'rlink-repos/components/Picture';

export default class CitySection extends Component {

  updatePosition () {
    let block = document.querySelector('#pictures .view-content');

    //Establish grid values
    let firstItem = block.querySelector('.views-row-first');
    let cellWidth = firstItem.offsetWidth;
    let cellHeight = firstItem.offsetHeight;

    //Loop through grid
    let cellMaxIndex = 2;
    let cellCount = 0;
    let rowCount = 0;
    let gridMap = [];
    if (legacyIsDesktop()) {
      gridMap = [
        Array(3).fill(false),
        Array(3).fill(false),
        Array(3).fill(false),
      ];
    } else {
      cellMaxIndex = 0;
      gridMap = [
        Array(9).fill(false),
      ];
    }

    Array.from(block.querySelectorAll('.views-row')).forEach(item => {
      //Check for blocks that take up more than one cell and adjust
      while (gridMap[cellCount][rowCount] === true) {
        cellCount++;
        if (cellCount > gridMap.length - 1) {
          cellCount = 0;
          rowCount++;
        }
      }

      gridMap[cellCount][rowCount] = true;
      if (item.offsetHeight / cellHeight > 1) {
        gridMap[cellCount][rowCount + 1] = true;
      }

      let leftVal = cellWidth * cellCount;
      let topVal = cellHeight * rowCount;

      item.setAttribute('style', `transition: all 0.4s;position:absolute;top:${topVal}px;left:${leftVal}px;`);
      cellCount++;
      if (cellCount > cellMaxIndex) {
        cellCount = 0;
        rowCount++;
      }
    });

    //Init Block
    let lastItem = block.querySelector('.views-row-last');
    let calculatedHeight = parseInt(lastItem.style.top) + lastItem.offsetHeight;
    block.setAttribute(
      'style',
      `position:relative;height: ${calculatedHeight}px;`
    );
  }

  waitForFinalResize (callback, ms) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(callback, ms);
  }

  componentDidMount () {
    this.iconTimeline = new TimelineMax();
    this.updatePosition();
    window.addEventListener('resize', () => {
      this.waitForFinalResize(this.updatePosition, 300);
    });
    statsScene(this.iconTimeline);
    cityScene(this.iconTimeline, () => this.updatePosition());
  }

  render () {
    return (
      <div>
        <article id="pictures" className=" clearfix">
          <p />
          <div className="view view-pictures view-id-pictures view-display-id-pictures_block view-dom-id-1b5d8b2862c4b4431fa320f4467343f0">
            <div className="view-content">
              {this.props.cityGalleryImagesData.map((galleryImage, index) => {
                let className = `views-row views-row-${index + 1} views-row-${(index + 1) % 2 ? 'odd' : 'even'}`
                if (index === 0) {
                  className += ' views-row-first'
                }
                if (index === this.props.cityGalleryImagesData.length - 1) {
                  className += ' views-row-last'
                }

                return (
                  <div key={galleryImage.imagePath} className={className}>
                    <article className="node node-picture node-promoted node-teaser">
                      <div className="image">
                        <Picture
                          src={galleryImage.mainImageFormats.src}
                          widths={galleryImage.mainImageFormats.widths}
                          heights={galleryImage.mainImageFormats.heights}
                          formats={galleryImage.mainImageFormats.formats}
                        />
                      </div>
                      <div className="overlay-column">
                        <div className="picture-border">
                          <div className="container">
                            <div>
                              <h5 className="node-title noline">{galleryImage.title}</h5>
                              <div className="body text-secondary">{galleryImage.subtitle}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                )
              })}
            </div>
          </div>
        </article>
        <article id="stats" className="layout-wide bg-black text-white clearfix">
          <div className="wrapper">
            <div className="row">
              <h3>VANCOUVER IN NUMBERS</h3>
              <div id="stat-population" className="stat">
                <em id="icon-population">
                  <IconPopulation />
                </em>
                <p>The population of greater Vancouver is{' '}
                <span className="text-primary">2.1million</span> and it is one of the most{' '}
                <span className="text-primary">ethnically diverse</span> cities in Canada.</p>
              </div>
              <div id="stat-location" className="stat">
                <em id="icon-location">
                  <IconLocation />
                </em>
                <p>
                  <span className="text-primary">3 ski mountains</span> are located on the outskirts of Vancouver and world-renowned{' '}
                <span className="text-primary">Whistler resort</span> is only 90 minutes away.</p>
              </div>
              <div id="stat-diverse" className="stat">
                <svg id="icon-diverse" />
                <p>A mecca for the creative industry, Vancouver is home to{' '}
                <span className="text-primary">44% of Canadian game developers</span> and a thriving film sector. Vancouver truly is{' '}
                <span className="text-primary">Hollywood North.</span>
                </p>
              </div>
              <div id="stat-nationalpark" className="stat">
                <em id="icon-nationalpark">
                  <IconNationalPark />
                </em>
                <p>Stanley Park is{' '}
                <span className="text-primary">one of the largest parks in North America</span> covering 1001 acres making it 10% larger than New York’s
                Central Park.</p>
              </div>
            </div>
          </div>
        </article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/AboutUs/CitySection.jsx